import { Routes, Route, Navigate } from "react-router";
import { useAuth } from "../context/AuthContext";
import PrivateRoutes from "./PrivateRoute";
import App from "../App";
import Dashboard from "../pages/Dashboard";
import Employees from "../pages/Employees";
import NewEmployee from "../pages/NewEmployee";
import EmployeeDetail from "../pages/EmployeeDetail";
import Tablets from "../pages/Tablets";
import NewTablet from "../pages/NewTablet";
import PanelUsers from "../pages/PanelUsers";
import NewPanelUser from "../pages/NewPanelUser";
import Settings from "../pages/Settings";
import GeneralSettings from "../pages/GeneralSettings";
import DepartmentSettings from "../pages/DepartmentSettings";
import NewDepartment from "../pages/NewDepartment";
import RoleSettings from "../pages/RoleSettings";
import NewRole from "../pages/NewRole";
import SkillSettings from "../pages/SkillSettings";
import NewSkill from "../pages/NewSkill";
import ContractSettings from "../pages/ContractSettings";
import NewContract from "../pages/NewContract";
import PublicRoutes from "./PublicRoute";
import LoginPage from "../pages/LoginPage";
import Calendar from "../pages/Calendar";
import Applicants from "../pages/Applicants";
import NewApplicant from "../pages/NewApplicant";

export default function AppRoutes() {
  const { company } = useAuth();

  return (
    <Routes>
      <Route element={<PrivateRoutes />}>
        <Route path="/" element={<App />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} index />
          {company?.modules?.isCalendarAvailable && (
            <Route path="calendar" element={<Calendar />} index />
          )}

          <Route path="employees">
            <Route index element={<Employees />} />
            <Route path="new" element={<NewEmployee />} />
            <Route path=":id" element={<EmployeeDetail />} />
          </Route>
          <Route path="tablets">
            <Route index element={<Tablets />} />
            <Route path="new" element={<NewTablet />} />
          </Route>
          {company?.modules?.isApplicantAvailable && (
            <Route path="human-resources" element={<Settings />}>
              <Route path="cv-pool">
                <Route index element={<Applicants />} />
                <Route path="new" element={<NewApplicant />} />
              </Route>
            </Route>
          )}
          <Route path="panel-users">
            <Route index element={<PanelUsers />} />
            <Route path="new" element={<NewPanelUser />} />
          </Route>
          {/* <Route path="reports" element={<Reports />}>
                    <Route path="monthly-report" element={<MonthlyReport />} />
                    <Route
                      path="entry-exit-reports"
                      element={<EntryExitReport />}
                    />
                    <Route path="delay-list" element={<DelayList />} />
                  </Route> */}
          {/* <Route path="shifts" element={<Shifts />}>
                    <Route
                      path="shift-assignment"
                      element={<ShiftAssignment />}
                    />

                    <Route path="work-shift">
                      <Route index element={<WorkShiftSettings />} />
                      <Route path="new" element={<NewWorkShift />} />
                      <Route path=":id" element={<WorkShiftDetail />} />
                    </Route>
                  </Route> */}

          <Route path="settings" element={<Settings />}>
            <Route path="general" element={<GeneralSettings />} />
            <Route path="department">
              <Route index element={<DepartmentSettings />} />
              <Route path="new" element={<NewDepartment />} />
              {/* <Route
                        path=":id"
                        element={<div>Departman Detayları</div>}
                      /> */}
            </Route>
            <Route path="role">
              <Route index element={<RoleSettings />} />
              <Route path="new" element={<NewRole />} />
              {/* <Route path=":id" element={<div>Role Details</div>} /> */}
            </Route>
            <Route path="skill">
              <Route index element={<SkillSettings />} />
              <Route path="new" element={<NewSkill />} />
              {/* <Route path=":id" element={<div>skill Details</div>} /> */}
            </Route>
            <Route path="contract">
              <Route index element={<ContractSettings />} />
              <Route path="new" element={<NewContract />} />
              {/* <Route path=":id" element={<div>Contract Details</div>} /> */}
            </Route>
          </Route>

          <Route path="*" element={<div>404 NOT FOUND</div>} />
        </Route>
      </Route>
      <Route element={<PublicRoutes />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>
    </Routes>
  );
}
